// extracted by mini-css-extract-plugin
module.exports = {"awardContainer":"award_awardContainer__qfcZQ","right":"award_right__dga9M","left":"award_left__M840O","content":"award_content__Vknn_"};